<ngx-spinner size="small" color="#C97514" type="line-scale"></ngx-spinner>
<app-header *ngIf="service.isLoggedIn()"></app-header>
<router-outlet></router-outlet>
<app-sidemenu *ngIf="service.isLoggedIn()"></app-sidemenu>
<app-footer *ngIf="service.isLoggedIn()"></app-footer>